import React from 'react'

import { colors } from 'helpers/colors'

function SvgWarningSolid({ size = 30, color = colors.gray[700] }) {
  return (
    <svg width={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.7,40,25.8,4a2.1,2.1,0,0,0-3.5,0L2.3,40A2,2,0,0,0,4,43H44A2,2,0,0,0,45.7,40ZM24,36a2,2,0,1,1,2-2A2,2,0,0,1,24,36Zm2-8a2,2,0,0,1-4,0V19a2,2,0,0,1,4,0Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgWarningSolid
